import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import type { EntityType } from '../models/entity-type.model';

@Injectable({
  providedIn: 'root'
})
export class EntityTypeService {
  constructor(private http: HttpClient) {}

  getEntityTypes(): Observable<EntityType[]> {
    return this.http.get<EntityType[]>(`${environment.apiUrl}/config/entity-types`);
  }
}
